import { render, staticRenderFns } from "./OilLife.vue?vue&type=template&id=6b32e421&scoped=true&"
import script from "./OilLife.vue?vue&type=script&lang=js&"
export * from "./OilLife.vue?vue&type=script&lang=js&"
import style0 from "./OilLife.vue?vue&type=style&index=0&id=6b32e421&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b32e421",
  null
  
)

export default component.exports